<div class="array-questions">
    <div class="title" *ngIf="to.label">{{ to.label }}</div>
    <div class="description mat-hint" *ngIf="to.description">{{ to.description }}</div>

    <txp-message [type]="messageType.DANGER" *ngIf="showError && formControl.errors">
        <formly-validation-message [field]="field"></formly-validation-message>
    </txp-message>

    <div class="question-list">
        <div *ngFor="let field of field.fieldGroup;let i = index;" class="question">
            <formly-field [field]="field"></formly-field>
            <div>
                <txp-button [size]="buttonSize.SMALL" [hidden]="field.formControl.disabled"
                            [style]="buttonStyle.NOBACKGROUND"
                            icon="tce-icon-trash"
                            (click)="remove(i)">{{ 'form.button.remove' | translate }}
                </txp-button>
            </div>
        </div>
    </div>

    <div class="actions">
        <txp-button [size]="buttonSize.SMALL" [hidden]="field.formControl.disabled"
                    [style]="buttonStyle.SECONDARY"
                    (click)="add()">{{ 'form.button.addTo' | translate }} {{ to.label }}
        </txp-button>
    </div>
</div>
